/**
 * Classe représentant un capteur Muse (bandeau)
 * @module Muse
 */

import Device from './Device';

export default class Muse extends Device
{
/** Représenter le capteur bluetooth
 * @construtor
 * @param {hexadecimal} aPrimaryService - Valeur hexadecimale du service primaire de l'appareil bluettoth
 * @param {hexadecimal} aCharateristicTP9 - Valaur représentaant la donnée à exploiter selon le capteur TP9
 * @param {hexadecimal} aCharateristicAF7 - Valaur représentaant la donnée à exploiter selon le capteur AF7
 * @param {hexadecimal} aCharateristicAF8 - Valaur représentaant la donnée à exploiter selon le capteur AF8
 * @param {hexadecimal} aCharateristicTP10 - Valaur représentaant la donnée à exploiter selon le capteur TP10
 * @param aAF7sensor
 * @param aAF8sensor
 * @param aTP9sensor
 * @param aTP10sensor
 */
  constructor(aPrimaryService, aCharateristicTP9, aCharateristicAF7, aCharateristicAF8, aCharateristicTP10, aAF7sensor, aAF8sensor, aTP9sensor, aTP10sensor)
  {
    super(aPrimaryService);
    this.characteristicTP9 = aCharateristicTP9;
    this.characteristicAF7 = aCharateristicAF7;
    this.characteristicAF8 = aCharateristicAF8;
    this.characteristicTP10 = aCharateristicTP10;
    this.AF7sensor = aAF7sensor;
    this.AF8sensor = aAF8sensor;
    this.TP9sensor = aTP9sensor;
    this.TP10sensor = aTP10sensor;
    this.isActive = false;
    this.ratioMin = 0;
    this.ratioMax = 2048;
    this.ratio = 0;
    this.bufferRatio = [];
    this.arrayRatio = [];
    this.valeursBrutes = [];

    this.smoothAlphaMetrics = 0;
    this.smoothAlphaMetricsMin = 0;
    this.smoothAlphaMetricsMax = 0;

    this.smoothThetaMetrics = 0;
    this.smoothThetaMetricsMin = 0;
    this.smoothThetaMetricsMax = 0;

    this.smoothBetaMetrics = 0;
    this.smoothBetaMetricsMin = 0;
    this.smoothBetaMetricsMax = 0;

    this.smoothGammaMetrics = 0;
    this.smoothGammaMetricsMin = 0;
    this.smoothGammaMetricsMax = 0;

    this.smoothDeltaMetrics = 0;
    this.smoothDeltaMetricsMin = 0;
    this.smoothDeltaMetricsMax = 0;

    this.alphaCalibrated = 0;
    this.thetaCalibrated = 0;
    this.deltaCalibrated = 0;
    this.gammaCalibrated = 0;
    this.betaCalibrated = 0;

    this.coefficient = 1.5;

    this.isCalibrated = false;
  }


  /** Etablir une connexion de l'appareil bluetooth
     * @function
     * @param {Button} button - Boutton permettant l'activation de la connexion afin de lui donner en titre, le nom de l'appareil
     */
  async connexion()
  {
    console.log('Trying to connect the muse.')
    let isConnected = false;

    const deviceOptions = {
      filters : [
        {namePrefix : 'Muse'}
      ],
      optionalServices : [this.primaryService]
    } ;

    await navigator.bluetooth.requestDevice(deviceOptions)
      .then(function (device) {
        // Connection au protocole Gatt
        return device.gatt.connect();
      })
      .then(server => {
        // Récupération du premier service
        return server.getPrimaryService(this.primaryService)
      })
      .then(service => {
        return Promise.all([
          service.getCharacteristic(this.characteristicTP9)
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
              characteristic.addEventListener('characteristicvaluechanged', this.TP9sensor.handleCharacteristicValueChanged);
            }),
          service.getCharacteristic(this.characteristicAF7)
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
              characteristic.addEventListener('characteristicvaluechanged', this.AF7sensor.handleCharacteristicValueChanged);
            }),
          service.getCharacteristic(this.characteristicAF8)
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
              characteristic.addEventListener('characteristicvaluechanged', this.AF8sensor.handleCharacteristicValueChanged);
            }),
          service.getCharacteristic(this.characteristicTP10)
            .then(characteristic => characteristic.startNotifications())
            .then(characteristic => {
              characteristic.addEventListener('characteristicvaluechanged', this.TP10sensor.handleCharacteristicValueChanged);
            }),
          service.getCharacteristic('273e0001-4c4d-454d-96be-f03bac821358')
            .then(characteristic => {
              var buffer = new ArrayBuffer(3) ;
              var command = new Uint8Array(buffer);
              command.set([0x02, 0x64, 0x0a]);
              characteristic.writeValue(command, "never")
              console.log('Muse connected.')
              isConnected = true;
            })
        ])
      })
      .catch(error =>
        {
          console.error(error);
          isConnected = false;
        }
      );

      return isConnected;
  }

  /** Récupérer le ratio issu des différentes transformations de calcul
   * @function
   * @return Ratio : Theta/Alpha
   */
  getRatioAlphaOfDelta()
  {
    if (((this.TP10sensor.smoothDeltaMetrics + this.TP9sensor.smoothDeltaMetrics)/2) !== 0)
    {
      this.ratio = (((this.AF7sensor.smoothAlphaMetrics + this.AF8sensor.smoothAlphaMetrics)/2)/((this.TP10sensor.smoothDeltaMetrics + this.TP9sensor.smoothDeltaMetrics)/2));
      this.ratio = (this.ratio - this.ratioMin)/(this.ratioMax - this.ratioMin);
    }
    return this.ratio;
  }

  getRatioBetaOfTheta()
  {
    if (((this.TP10sensor.smoothThetaMetrics + this.TP9sensor.smoothThetaMetrics)/2) !== 0)
    {
      this.ratio = (((this.AF7sensor.smoothBetaMetrics + this.AF8sensor.smoothBetaMetrics)/2)/((this.TP10sensor.smoothThetaMetrics + this.TP9sensor.smoothThetaMetrics)/2));
      this.ratio = (this.ratio - this.ratioMin)/(this.ratioMax - this.ratioMin);
    }
    return this.ratio;
  }

  getAlpha()
  {
    var alpha = ((this.AF7sensor.smoothAlphaMetrics + this.AF8sensor.smoothAlphaMetrics + this.TP9sensor.smoothAlphaMetrics + this.TP10sensor.smoothAlphaMetrics)/4)
    if(this.isCalibrated === false)
    {
      this.smoothAlphaMetrics = alpha;
    }
    else
    {
      this.smoothAlphaMetrics = this.normalisation(alpha, this.smoothAlphaMetricsMin, this.smoothAlphaMetricsMax, this.alphaCalibrated);
    }

    return this.smoothAlphaMetrics;
  }

  getTheta() {
    var theta = ((this.AF7sensor.smoothThetaMetrics + this.AF8sensor.smoothThetaMetrics + this.TP9sensor.smoothThetaMetrics + this.TP10sensor.smoothThetaMetrics) / 4);
    if (this.isCalibrated === false)
    {
      this.smoothThetaMetrics = theta;
    }
    else
    {
      this.smoothThetaMetrics = this.normalisation(theta, this.smoothThetaMetricsMin, this.smoothThetaMetricsMax, this.thetaCalibrated);
    }

    return this.smoothThetaMetrics;
  }

  getBeta() {

    var beta = ((this.AF7sensor.smoothBetaMetrics + this.AF8sensor.smoothBetaMetrics + this.TP9sensor.smoothBetaMetrics + this.TP10sensor.smoothBetaMetrics) / 4);

    if (this.isCalibrated === false)
    {
      this.smoothBetaMetrics = beta;
    }
    else
    {
      this.smoothBetaMetrics = this.normalisation(beta, this.smoothBetaMetricsMin, this.smoothBetaMetricsMax, this.betaCalibrated);
    }


    return this.smoothBetaMetrics;
  }

  getGamma()
  {
    var gamma = ((this.AF7sensor.smoothGammaMetrics + this.AF8sensor.smoothGammaMetrics + this.TP9sensor.smoothGammaMetrics + this.TP10sensor.smoothGammaMetrics) / 4);

    if (this.isCalibrated === false)
    {
      this.smoothGammaMetrics = gamma;
    }
    else
    {
      this.smoothGammaMetrics = this.normalisation(gamma, this.smoothGammaMetricsMin, this.smoothGammaMetricsMax, this.gammaCalibrated)
    }

    return this.smoothGammaMetrics;
  }

  getDelta()
  {
    var delta = ((this.AF7sensor.smoothDeltaMetrics + this.AF8sensor.smoothDeltaMetrics + this.TP9sensor.smoothDeltaMetrics + this.TP10sensor.smoothDeltaMetrics) / 4);
    if (this.isCalibrated === false)
    {
      this.smoothDeltaMetrics = delta;
    }
    else
    {

      this.smoothDeltaMetrics = this.normalisation(delta, this.smoothDeltaMetricsMin, this.smoothDeltaMetricsMax, this.deltaCalibrated);
    }


    return this.smoothDeltaMetrics;
  }

  normalisation(eeg, smoothMetricsMin, smoothMetricsMax, smoothMetricsRef)
  {
    if(eeg < smoothMetricsMin)
    {
      eeg = smoothMetricsMin;
    }
    else if(eeg > smoothMetricsMax)
    {
      eeg = smoothMetricsMax;
    }

    if (eeg < smoothMetricsRef)
    {
      return ((eeg-smoothMetricsMin)/(smoothMetricsRef - smoothMetricsMin))/2;
    }
    else if (eeg > smoothMetricsRef)
    {
      return ((eeg-smoothMetricsRef)/(smoothMetricsMax - smoothMetricsRef))/2+0.5;
    }
    else
    {
      return 0.5;
    }
  }

  calibrate()
  {
    this.alphaCalibrated = ((this.AF7sensor.smoothAlphaMetrics + this.AF8sensor.smoothAlphaMetrics + this.TP9sensor.smoothAlphaMetrics + this.TP10sensor.smoothAlphaMetrics)/4)
    this.thetaCalibrated = ((this.AF7sensor.smoothThetaMetrics + this.AF8sensor.smoothThetaMetrics + this.TP9sensor.smoothThetaMetrics + this.TP10sensor.smoothThetaMetrics)/4)
    this.betaCalibrated = ((this.AF7sensor.smoothBetaMetrics + this.AF8sensor.smoothBetaMetrics + this.TP9sensor.smoothBetaMetrics + this.TP10sensor.smoothBetaMetrics)/4)
    this.gammaCalibrated = ((this.AF7sensor.smoothGammaMetrics + this.AF8sensor.smoothGammaMetrics + this.TP9sensor.smoothGammaMetrics + this.TP10sensor.smoothGammaMetrics)/4)
    this.deltaCalibrated = ((this.AF7sensor.smoothDeltaMetrics + this.AF8sensor.smoothDeltaMetrics + this.TP9sensor.smoothDeltaMetrics + this.TP10sensor.smoothDeltaMetrics)/4)

    this.sliderCoefficient();
    console.log(this.coefficient)
  }

  sliderCoefficient()
  {
    this.smoothAlphaMetricsMin = this.alphaCalibrated - this.coefficient * this.alphaCalibrated ;
    this.smoothAlphaMetricsMax = this.alphaCalibrated + this.coefficient * (1 - this.alphaCalibrated) ;

    this.smoothThetaMetricsMin = this.thetaCalibrated - this.coefficient * this.thetaCalibrated ;
    this.smoothThetaMetricsMax = this.thetaCalibrated + this.coefficient * (1 - this.thetaCalibrated) ;

    this.smoothDeltaMetricsMin = this.deltaCalibrated - this.coefficient * this.deltaCalibrated ;
    this.smoothDeltaMetricsMax = this.deltaCalibrated + this.coefficient * (1 - this.deltaCalibrated) ;

    this.smoothGammaMetricsMin = this.gammaCalibrated - this.coefficient * this.gammaCalibrated ;
    this.smoothGammaMetricsMax = this.gammaCalibrated + this.coefficient * (1 - this.gammaCalibrated) ;

    this.smoothBetaMetricsMin = this.betaCalibrated - this.coefficient * this.betaCalibrated ;
    this.smoothBetaMetricsMax = this.betaCalibrated + this.coefficient * (1 - this.betaCalibrated) ;

    this.isCalibrated = true;
  }
}
